import axios from 'axios';
import useAxios from 'axios-hooks';
import moment from "moment";
import React, { useState } from "react";
import {
  Alert, Button, Card, Col, Container, Form, FormGroup, Modal, ProgressBar, Row
} from "react-bootstrap";
import cssModules from "react-css-modules";
import { FormattedMessage, injectIntl } from "react-intl";
import { queryCache, useMutation, useQuery } from "react-query";
import { Redirect } from "react-router-dom";
import { default as SAlert } from "react-s-alert";
import Spinner from "react-spinkit";
import style from "./style.scss";


const fetchPresentations = (cacheKeyBase, event_id, speaker_id) => axios({
  url: `${process.env.REACT_APP_API_HOST}/speaker-event/${event_id}/${speaker_id}`,
  method: 'GET',
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
}).then(response => response.data.data)

const changePresentationPrivacy = ({ pptInfo, updateObject }) => axios({
  url: `${process.env.REACT_APP_API_HOST}/public-presentation/${pptInfo._id}/changePresentationPrivacy/${pptInfo.event_id}/${pptInfo.speaker_id}`,
  method: 'PATCH',
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  data: updateObject
}).then(response => response.data.data)

const UploadVideo = ({ match: { params } }) => {
  return <Redirect to={`/speaker-data/${params.event_id}/${params.speaker_id}?manage=video-upload`} />
}

const UploadVideoasd = ({ match, intl, dispatch }) => {

  return <pre>{JSON.stringify(match, null, 2)}</pre>

  const { isLoading, isError, error, data } = useQuery(['speaker-presentations', match.params.event_id, match.params.speaker_id], fetchPresentations, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  if(isLoading) {
    return <div className="section-padding-page">
      <Container>
        <Spinner spinnername="wave" />
      </Container>
    </div>
  }

  if(isError) {
    return <div className="section-padding-page">
      <Container>
        <i>There was an error: <pre>{JSON.stringify(error)}</pre>.</i>
      </Container>
    </div>
  }

  const { event, presentations } = data;

  return (
    <div className="section-padding-page">
      <Container>
        <Row>
          <Col xs={12}>
            <h1 className="post-header">{event.name}</h1>
            <div className="event-details margin-bot-20">
              {event.venue ? (
                <span>
                  <span>
                    <i className="fa fa-map-signs" /> {event.venue}
                  </span>
                  <span>
                    <i className="fa fa-calendar" />{" "}
                    {moment(event.start).isSame(
                      event.end,
                      "day"
                    )
                      ? moment(event.start).format("DD/MM/YYYY")
                      : `${moment(event.start).format(
                          "DD/MM/YYYY"
                        )} to ${moment(event.end).format(
                          "DD/MM/YYYY"
                        )}`}
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>
          </Col>
          {event.name && presentations.length === 0 ? (
            <Col xs={12}>
              <Alert variant="danger">
                <FormattedMessage id="label.no-presentations-for-upload" />
              </Alert>
            </Col>
          ) : (
            <Col xs={12}>
              <h2>
                <FormattedMessage id="heading.upload-video" />
              </h2>
              {presentations.map((p) => <PresentationCard key={p._id} p={p} {...match.params} intl={intl} />)}
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

const PresentationCard = ({ p, event_id, speaker_id, intl }) => {
  const [showModal, setShowModal] = useState(false);
  const [progress, setProgress] = useState(0);

  const [changePresentationPrivacyMutation, { isLoading: changePresentationPrivacyLoading }] = useMutation(changePresentationPrivacy, {
    onSuccess: (updatedPresentation) => {
      queryCache.setQueryData(['speaker-presentations', event_id, speaker_id], ({ event, presentations }) => ({
        event,
        presentations: presentations
        .map(presentation => presentation._id === updatedPresentation._id ? { ...presentation, ...updatedPresentation } : presentation)
      }))
      SAlert.success(intl.formatMessage({ id: "presentation.update-success" }));
    },
    onError: (err) => {
      SAlert.error(intl.formatMessage({ id: "error.server-error" }))
    }
  })

  const [{ loading: getVideoTokenLoading }, getVideoToken] = useAxios({
    url: `${process.env.REACT_APP_API_HOST}/public-presentation/${p._id}/getVideoToken/${event_id}/${speaker_id}`,
    method: "PATCH",
  }, {
    manual: true
  });

  const [{ loading: uploadVideoLoading }, uploadVideo] = useAxios({
    url: 'https://api.video.com/v1/videos',
    method: "POST",
    onUploadProgress: (progress) => {
      setProgress(parseInt(100 * progress.loaded / progress.total))
    }
  }, {
    manual: true
  });

  const [{ loading: updateVideoLoading }, updateVideo] = useAxios({
    url: `${process.env.REACT_APP_API_HOST}/public-presentation/${p._id}/updateVideo/${event_id}/${speaker_id}`,
    method: "PATCH"
  }, {
    manual: true
  });

  return <div>
    <Card key={p._id}>
      <Card.Header>{`${p.name}, ${moment(p.date).format(
        "DD/MM/YYYY"
      )} ${p.time}`}</Card.Header>
      <Card.Body>
        <FormGroup>
          <Form.Check
            data-presentation={p._id}
            data-public={p.public}
            checked={p.public}
            onChange={(e) => changePresentationPrivacyMutation({
              pptInfo: {
                _id: p._id,
                event_id: event_id,
                speaker_id: speaker_id,
              },
              updateObject: {
                public: e.target.checked,
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-broadcast",
            })}
            disabled={changePresentationPrivacyLoading}
          />
        </FormGroup>
        <FormGroup>
          <Form.Check
            data-presentation={p._id}
            data-pdf-convert={p.pdfConvert}
            checked={p.pdfConvert}
            onChange={(e) => changePresentationPrivacyMutation({
              pptInfo: {
                _id: p._id,
                event_id: event_id,
                speaker_id: speaker_id,
              },
              updateObject: {
                pdfConvert: e.target.checked,
              }
            })}
            label={intl.formatMessage({
              id: "label.agree-pdfConvert",
            })}
            disabled={changePresentationPrivacyLoading}
          />
        </FormGroup>
        { /*
        <ManagePresentation
          signingUrl="/s3/speaker"
          signingUrlQueryParams={{
            event_id: match.params.event_id,
            speaker_id: match.params.speaker_id,
            presentation_id: p._id,
          }}
          addFile={this.addPresentationAsSpeaker}
          presentations={p.ppt}
          presentation_name={p.name}
          presentation_id={p._id}
        />
        */ }
        <Button variant="primary" onClick={() => setShowModal(true)}>Upload Video</Button>
        <Modal show={showModal} onHide={() => {}}>
          <Modal.Header>
            <Modal.Title>Upload video for {p.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input type="file" accept="video/mp4,video/x-m4v,video/*" onChange={async (e) => {
              const file = e.target.files[0];
              try {
                const tokenResponse = await getVideoToken();
                const uploadToken = tokenResponse.data.data;

                var formData = new FormData();
                formData.append("image", file);
                formData.append("token", uploadToken);
                const videoUpload = await uploadVideo({
                  data: formData
                });

                await updateVideo({
                  data: {
                    video_id: videoUpload.data.id,
                    security_token: videoUpload.data.security_token,
                  }
                })
              } catch (e) {
                console.log('debug: ', e);
                SAlert.error(intl.formatMessage({ id: "error.server-error" }))
              }
              setProgress(0);
              SAlert.success(intl.formatMessage({ id: "presentation.update-success" }));
            }} />
            {
              progress
                ? <ProgressBar now={progress} variant="primary" />
                : <div />
            }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)} disabled={getVideoTokenLoading || uploadVideoLoading || updateVideoLoading}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
    <br />
  </div>
}

export default cssModules(injectIntl(UploadVideo), style);
